import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"search\">\n    <path fill-rule=\"evenodd\" d=\"M13.334 15.7a8.522 8.522 0 0 1-4.762 1.446C3.842 17.146 0 13.305 0 8.573S3.841 0 8.572 0c4.732 0 8.573 3.841 8.573 8.573a8.527 8.527 0 0 1-1.446 4.762l3.811 3.81a1.674 1.674 0 0 1-2.365 2.365l-3.811-3.81zM8.572 3.027a5.548 5.548 0 0 1 5.546 5.546 5.548 5.548 0 0 1-5.546 5.546 5.549 5.549 0 0 1-5.546-5.546 5.549 5.549 0 0 1 5.546-5.546z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol